import React, { useState, useEffect } from 'react'
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { TimesheetUpdateClass } from '../../interfaces/TimesheetUpdateClass';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import { ShowToast } from '../../common/Toastr';
import { updateCopyTimesheetState, addCopyAccountEmployeeTimeEntryAsync, getTimesheetTemplateAsync, getTimesheetPeriodAsync } from './timesheetSlice';
import { useTranslation } from 'react-i18next';
import { format, parse } from 'date-fns';
import { getValueFromResource } from '../../common/timeLiveFunction';
const TimesheetCopyWidget = () => {
    // const [singleDate, setSingleDate] = useState<Date | null>(new Date());
    const [singleDate, setSingleDate] = useState(new Date());
    const { accountEmployeeTimeEntryPeriodId, startDate, endDate, accountEmployeeId, timeEntryViewType, timeEntriesList, isCopyTimesheet, isCopyActivities,
        copyTimeEntryAutoSave, showWorkType, defaultWorkTypeId, showCopyTimesheet, showCopyActivityTimesheet, showTemplateInTimesheet } = useAppSelector((state) => state.timesheet);
    const { dateInsertionFormat, CurrentCultureDateFormat, timeZoneId, calendarStartDay } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const onDateChange = (date: any, e: any) => {
        e.stopPropagation();
        setSingleDate(date);
    }

    useEffect(() => {
        if (copyTimeEntryAutoSave && isCopyTimesheet && isCopyActivities == false) {
            addCopyTimesheet()
        }
    }, [copyTimeEntryAutoSave]);

    const copyTimesheet = () => {
        // ShowSwalWithConfirmation('Are you sure to copy specified week data in current week?', "All your existing data in current week will be deleted by this action.", "Yes, Proceed")
        ShowSwalWithConfirmation(`You are copying ${format(singleDate, CurrentCultureDateFormat.toString())} period data in current period`, "All your current period entries will be removed.", "Yes, Proceed")
            .then((result) => {
                if (result) {
                    dispatch(updateCopyTimesheetState({ "isCopyTimesheet": true, "isCopyActivities": false, "copyTimesheetDate": moment(singleDate).format(dateInsertionFormat) }));
                    setSingleDate(new Date());
                }
            })
            .catch((error) => {
            });
    }

    const copyActivities = () => {
        // ShowSwalWithConfirmation('Are you sure to copy specified week data in current week?', "All your existing data in current week will be deleted by this action.", "Yes, Proceed")
        ShowSwalWithConfirmation(`You are copying ${format(singleDate, CurrentCultureDateFormat.toString())} period data in current period`, "All your current period entries will be removed.", "Yes, Proceed")
            .then((result) => {
                if (result) {
                    dispatch(updateCopyTimesheetState({ "isCopyTimesheet": true, "isCopyActivities": true, "copyTimesheetDate": moment(singleDate).format(dateInsertionFormat) }));
                    setSingleDate(new Date());
                }
            })
            .catch((error) => {
            });
    }

    const addCopyTimesheet = () => {
        let copyTimeEntriesArray: TimesheetUpdateClass[] = [];
        for (var i = 0; i < timeEntriesList.length; i++) {
            let obj = timeEntriesList[i];
            if (obj.TaskName != null && obj.Completed != '1') {
                obj.timeEntries.map((item: any) => {
                    let copyObject: TimesheetUpdateClass = {
                        AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
                        AccountEmployeeTimeEntryApprovalProjectId: '',
                        AccountEmployeeTimeEntryId: 0,
                        AccountEmployeeId: 0,
                        AccountClientId: 0,
                        AccountProjectId: 0,
                        AccountProjectTaskId: 0,
                        AccountCostCenterId: 0,
                        AccountWorkTypeId: 0,
                        AccountTimeOffTypeId: null,
                        Hours: 0,
                        Percentage: null,
                        PeriodStartDate: '',
                        PeriodEndDate: '',
                        TimeEntryDate: '',
                        StartTime: null,
                        EndTime: null,
                        IsTimeOff: false,
                        TimesheetPeriodType: '',
                        IsSubmitted: false,
                        Description: '',
                        CustomField1: '',
                        CustomField2: '',
                        CustomField3: '',
                        CustomField4: '',
                        CustomField5: '',
                        CustomField6: '',
                        CustomField7: '',
                        CustomField8: '',
                        CustomField9: '',
                        CustomField10: '',
                        CustomField11: '',
                        CustomField12: '',
                        CustomField13: '',
                        CustomField14: '',
                        CustomField15: '',
                        RowId: 0,
                        DetailRowId: 0,
                        TimeZoneId: 0,
                        Reason:'',
                        SystemPlatformSourceId: "3D9FD131-9B80-43DA-AD66-CBE010F1B5A6",
                    };
                    if (item.Hours > 0) {
                        copyObject.AccountEmployeeTimeEntryPeriodId = accountEmployeeTimeEntryPeriodId;
                        copyObject.AccountEmployeeTimeEntryApprovalProjectId = obj.AccountEmployeeTimeEntryApprovalProjectId;
                        copyObject.AccountEmployeeTimeEntryId = 0;
                        copyObject.AccountEmployeeId = accountEmployeeId
                        copyObject.AccountClientId = obj.AccountClientId;
                        copyObject.AccountProjectId = obj.AccountProjectId;
                        copyObject.AccountProjectTaskId = obj.AccountProjectTaskId;
                        copyObject.AccountCostCenterId = obj.AccountCostCenterId;
                        copyObject.AccountWorkTypeId = showWorkType ? obj.AccountWorkTypeId : defaultWorkTypeId;
                        copyObject.AccountTimeOffTypeId = obj.AccountTimeOffTypeId ? obj.AccountTimeOffTypeId : null;
                        copyObject.Hours = item.Hours;
                        copyObject.Percentage = null;
                        copyObject.PeriodStartDate = startDate;
                        copyObject.PeriodEndDate = endDate;
                        copyObject.TimeEntryDate = item.TimeEntryDate;
                        copyObject.StartTime = item.TimeEntryDate + " " + item.StartTime;
                        copyObject.EndTime = item.TimeEntryDate + " " + item.EndTime;
                        copyObject.IsTimeOff = obj.isTimeOff;
                        copyObject.TimesheetPeriodType = timeEntryViewType;
                        copyObject.IsSubmitted = false;
                        copyObject.Description = item.Description;
                        copyObject.CustomField1 = item.CustomField1;
                        copyObject.CustomField2 = item.CustomField2;
                        copyObject.CustomField3 = item.CustomField3;
                        copyObject.CustomField4 = item.CustomField4;
                        copyObject.CustomField5 = item.CustomField5;
                        copyObject.CustomField6 = item.CustomField6;
                        copyObject.CustomField7 = item.CustomField7;
                        copyObject.CustomField8 = item.CustomField8;
                        copyObject.CustomField9 = item.CustomField9;
                        copyObject.RowId = obj.rowId;
                        copyObject.DetailRowId = obj.rowId;
                        copyObject.TimeZoneId = timeZoneId;
                    }
                    item.Hours > 0 && copyTimeEntriesArray.push(copyObject);
                });
            }
        }
        dispatch(addCopyAccountEmployeeTimeEntryAsync(copyTimeEntriesArray))
            .unwrap()
            .then((originalPromiseResult) => {               
                dispatch(getTimesheetPeriodAsync());
                const { oldAccountEmployeeTimeEntryId } = originalPromiseResult;
                if (oldAccountEmployeeTimeEntryId == 0) {                 
                    ShowToast('Success', 'Time Entry Added Successfully!', "success", "toast-top-right");
                }
                else {
                    ShowToast('Success', 'Time Entry Updated Successfully!', "success", "toast-top-right");
                }
            })
            .catch((rejectedValueOrSerializedError) => {
            })
            .finally(() => {
            });
    }

    const copyTimesheetTemplate = () => {
        dispatch(getTimesheetTemplateAsync())
            .unwrap()
            .then((result) => {
                if (!result[0].hasOwnProperty('Message')) {
                    ShowToast('Success', 'Time Entry Updated Successfully!', "success", "toast-top-right");
                }
                else {
                    ShowToast('Information', 'No records found. Please create a timesheet template.', "info", "toast-top-right");
                }
            })
            .catch((error) => {
            })
            .finally(() => {
            });
    }

    return (
        <div className={"col-md-12 col-sm-12 col-xs-12 active show"}>
            <h4 className="headerTitle">
                {/* {t('Copy Timesheet')} */}
                {getValueFromResource('Copy Timesheet',dispatch, t)}
                </h4>
            <div className="separator my-1"></div>
            <div className='row mt-4 mb-4'>
                <span style={{ width: 164 }} className='mt-2 fs-6 fw-normal'>
                    {/* {t('Copy From Timesheet')} */}
                    {getValueFromResource('Copy From Timesheet',dispatch, t)}

                    </span>
                <div className='tsCopyDatepicker'>
                    <div className='d-flex flex-shrink-0'>
                        <DatePicker
                            selected={singleDate}
                            onChange={(date, e) => { onDateChange(date, e) }}
                            calendarStartDay={calendarStartDay}
                            customInput={<a style={{ cursor: 'pointer' }} >
                                <div className='d-flex align-items-center flex-wrap' style={{ marginTop: 0, marginLeft: 8 }}>
                                    {/* <span className='fs-6 fw-normal d-md-block headerTitleColor'>{moment(singleDate).format("DD-MM-YYYY")} */}
                                    <span className='fs-6 fw-normal d-md-block headerTitleColor'>{format(singleDate, CurrentCultureDateFormat.toString())}
                                    </span>
                                    <a className='btn btn-sm btn-icon btn-icon-primary show'>
                                        <i className="ki-outline ki-calendar iconColor fs-3"></i>
                                    </a>
                                </div>
                            </a>}
                        />
                    </div>
                </div>
            </div>
            <div className='d-flex align-items-center gap-2 gap-lg-3 mb-4'>
                {showCopyTimesheet && <a onClick={() => { copyTimesheet() }} className={"btn btn-light-primary btn-sm"}>
                    <i className="bi bi-files fs-5 fw-normal me-1"></i>
                    {/* {t('Copy Timesheet')} */}
                    {getValueFromResource('Copy Timesheet',dispatch, t)}

                </a>}
                {showCopyActivityTimesheet && <a onClick={() => { copyActivities() }} className={"btn btn-light-primary btn-sm"}>
                    <i className="bi bi-files fs-5 fw-normal me-1"></i>
                    {/* {t('Copy Activities')} */}
                    {getValueFromResource('Copy Activities',dispatch, t)}
                </a>
                }
            </div>
            {showTemplateInTimesheet && <><div className="separator my-1"></div>
                <h4 className="copyHTitle">{t('Copy Timesheet Template')}</h4>
                <div className="separator my-1"></div>
                <div className='d-flex align-items-center gap-2 gap-lg-3 mt-4'>
                    <a onClick={() => { copyTimesheetTemplate() }} className={"btn btn-light-primary btn-sm"}>
                        <i className="bi bi-files fs-5 fw-normal me-1"></i>
                        {/* {t('Copy From Template')} */}
                        {getValueFromResource('Copy From Template',dispatch, t)}
                    </a>
                </div>
            </>}
        </div>
    )
}

export default TimesheetCopyWidget